import { createBlocksModel, WidgetPropertyType } from '@wix/yoshi-flow-editor/blocks';
/*
  Place where blocks model is initialized.
  Blocks model allows you to define your Widget Public APIs in a single place.
  It will automatically provide `getExports` for Editor Script and provide typings based on the model for Viewer Script (via model.createController).
*/
export default createBlocksModel({
  widgetName: 'OLO',
  props: {
    // Here you can define your widget props
    myProp: {
      type: WidgetPropertyType.STRING,
    },
    sortedMenus: {
      // TODO: fix this when https://wix.slack.com/archives/CKDB50KE2/p1668693127598739 done
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: {} as any,
      isArray: true,
    },
    showUnavailableMenus: {
      type: WidgetPropertyType.BOOLEAN,
      defaultValue: true,
    },
    showExpiredMenus: {
      type: WidgetPropertyType.BOOLEAN,
      defaultValue: true,
    },
    unavailableMenusShownLast: {
      type: WidgetPropertyType.BOOLEAN,
      defaultValue: true,
    },
  },
  methods: {
    // Here you can define your widget public props
  },
  events: {
    // Here you can define events your widget will subscribe to
    widgetLoaded: {
      description: 'Fired when Widget loaded',
    },
  },
});
